import React from "react";

const DepositMethodIcon = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 5.0374V4.7998C15 2.8654 13.9344 1.7998 12 1.7998H4.00005C2.78645 1.7998 1.80005 2.7862 1.80005 3.9998V14.3998C1.80005 16.3342 2.86565 17.3998 4.80005 17.3998H14.4C16.3344 17.3998 17.4 16.3342 17.4 14.3998V7.9998C17.4 6.2758 16.5536 5.2422 15 5.0374ZM16.2 12.5998H13.2C12.428 12.5998 11.8 11.9718 11.8 11.1998C11.8 10.4278 12.428 9.7998 13.2 9.7998H16.2V12.5998ZM4.00005 2.9998H12C13.2616 2.9998 13.8 3.5382 13.8 4.7998V4.9998H4.00005C3.44885 4.9998 3.00005 4.551 3.00005 3.9998C3.00005 3.4486 3.44885 2.9998 4.00005 2.9998ZM14.4 16.1998H4.80005C3.53845 16.1998 3.00005 15.6614 3.00005 14.3998V5.95898C3.30005 6.11258 3.64005 6.1998 4.00005 6.1998H14.4C15.6616 6.1998 16.2 6.7382 16.2 7.9998V8.5998H13.2C11.7664 8.5998 10.6 9.7662 10.6 11.1998C10.6 12.6334 11.7664 13.7998 13.2 13.7998H16.2V14.3998C16.2 15.6614 15.6616 16.1998 14.4 16.1998ZM13.6081 10.3998H13.6161C14.0585 10.3998 14.4161 10.7582 14.4161 11.1998C14.4161 11.6414 14.0585 11.9998 13.6161 11.9998C13.1745 11.9998 12.8121 11.6414 12.8121 11.1998C12.8121 10.7582 13.1665 10.3998 13.6081 10.3998Z"
      fill="currentColor"
    />
  </svg>
);

export default DepositMethodIcon;
